// // src/components/ExpertRecommendations.js
// import React, { useState } from 'react';

// import {
//   Box,
//   Paper,
//   Typography,
//   Avatar,
//   Chip,
//   Button,
//   Grid,
//   Card,
//   CardContent,
//   CardActions
// } from '@mui/material';

// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import StarIcon from '@mui/icons-material/Star';

// import { styled } from '@mui/material/styles';
// const StyledCard = styled(Card)(({ theme }) => ({
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-8px)',
//     boxShadow: '0 20px 40px rgba(43,140,255,0.3)',
//   },
//   background: 'linear-gradient(145deg, rgba(15,15,20,0.95), rgba(10,10,15,0.9))',
//   border: '1px solid rgba(43,140,255,0.2)',
// }));

// const experts = [
//   {
//     id: 1,
//     name: 'Dr. Sarah Chen',
//     title: 'AI/ML Specialist',
//     avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
//     rating: 4.9,
//     expertise: ['Machine Learning', 'NLP', 'RAG Systems'],
//     availability: 'Next: Today 3PM',
//     price: '$89/hr'
//   },
//   {
//     id: 2,
//     name: 'Dr. Raj Patel',
//     title: 'Python Architect',
//     avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
//     rating: 4.8,
//     expertise: ['Django/DRF', 'FastAPI', 'LLM Integration'],
//     availability: 'Next: Tomorrow 10AM',
//     price: '$79/hr'
//   },
//   {
//     id: 3,
//     name: 'Aisha Khan',
//     title: 'DevOps Engineer',
//     avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150',
//     rating: 4.7,
//     expertise: ['Docker', 'Kubernetes', 'Streamlit Deploy'],
//     availability: 'Next: Today 5PM',
//     price: '$69/hr'
//   }
// ];

// export default function ExpertRecommendations({ onBookSession }) {
//   const [selectedExpert, setSelectedExpert] = useState(null);

//   return (
//     <Box sx={{ mt: 6 }}>
//       <Paper sx={{
//         p: 4,
//         mb: 4,
//         background: 'linear-gradient(135deg, rgba(43,140,255,0.1), rgba(0,120,255,0.05))',
//         border: '1px solid rgba(43,140,255,0.3)',
//         borderRadius: '20px'
//       }}>
//         <Typography variant="h4" sx={{ 
//           mb: 2, 
//           background: 'linear-gradient(90deg,#2b8cff,#6ea8ff)',
//           WebkitBackgroundClip: 'text',
//           WebkitTextFillColor: 'transparent',
//           fontWeight: 700 
//         }}>
//           👨‍💼 Expert Recommendations
//         </Typography>
//         <Typography sx={{ color: '#aaa', mb: 1 }}>
//           Book a 1:1 session with top experts based on your AI query
//         </Typography>
//       </Paper>

//       <Grid container spacing={3}>
//         {experts.map((expert) => (
//           <Grid item xs={12} sm={6} md={4} key={expert.id}>
//             <StyledCard sx={{ height: '100%' }}>
//               <CardContent sx={{ p: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Avatar 
//                     src={expert.avatar} 
//                     sx={{ width: 60, height: 60, mr: 2 }}
//                   />
//                   <Box>
//                     <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
//                       {expert.name}
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#aaa' }}>
//                       {expert.title}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <Box sx={{ mb: 2 }}>
//                   <Chip 
//                     icon={<StarIcon sx={{ color: '#ffd700' }} />} 
//                     label={`${expert.rating} (${25}+)`} 
//                     sx={{ mr: 1, mb: 1, background: 'rgba(255,215,0,0.1)' }}
//                   />
//                   <Chip 
//                     icon={<CalendarTodayIcon />} 
//                     label={expert.availability} 
//                     sx={{ mr: 1, mb: 1, background: 'rgba(43,140,255,0.1)' }}
//                   />
//                   <Chip 
//                     label={expert.price} 
//                     sx={{ background: 'rgba(0,255,127,0.1)', color: '#00ff7f' }}
//                   />
//                 </Box>

//                 <Box sx={{ mb: 2 }}>
//                   {expert.expertise.slice(0, 2).map((skill, i) => (
//                     <Chip 
//                       key={i}
//                       label={skill}
//                       size="small"
//                       sx={{ mr: 1, mb: 1, background: 'rgba(255,255,255,0.1)' }}
//                     />
//                   ))}
//                 </Box>

//                 <Typography variant="body2" sx={{ color: '#ccc', lineHeight: 1.6 }}>
//                   15+ years experience helping developers with {expert.title.toLowerCase()} projects
//                 </Typography>
//               </CardContent>
              
//               <CardActions sx={{ p: 3, pt: 0 }}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   onClick={() => {
//                     setSelectedExpert(expert);
//                     onBookSession(expert);
//                   }}
//                   sx={{
//                     borderRadius: '12px',
//                     py: 1.2,
//                     fontWeight: 600,
//                     background: 'linear-gradient(90deg,#2b8cff,#4da3ff)',
//                     boxShadow: '0 4px 15px rgba(43,140,255,0.4)',
//                     '&:hover': { background: 'linear-gradient(90deg,#1f6ed4,#2b8cff)' }
//                   }}
//                 >
//                   Book Session <ArrowForwardIcon sx={{ ml: 1 }} />
//                 </Button>
//               </CardActions>
//             </StyledCard>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import BookingModal from '../Chatbot/BookingModel'
// import {
//   Box,
//   Paper,
//   Typography,
//   Avatar,
//   Chip,
//   Button,
//   Grid,
//   Card,
//   CardContent,
//   CardActions
// } from '@mui/material';

// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import StarIcon from '@mui/icons-material/Star';
// import { useNavigate } from "react-router-dom";
// import { styled } from '@mui/material/styles';

// const StyledCard = styled(Card)(({ theme }) => ({
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-6px)',
//     boxShadow: '0 15px 30px rgba(43,140,255,0.25)',
//   },
//   background: 'linear-gradient(145deg, rgba(15,15,20,0.95), rgba(10,10,15,0.9))',
//   border: '1px solid rgba(43,140,255,0.2)',
// }));


// export default function ExpertRecommendations({ onBookSession, experts = [] }) {
//   const [selectedExpert, setSelectedExpert] = useState(null);
//   const [bookingOpen, setBookingOpen] = useState(false);
//   const navigate = useNavigate();
//   if (!experts.length) return null;
 


//   return (
//     <Box sx={{ mt: 2 }}>
      
//       {/* Header */}
//       <Paper
//         sx={{
//           p: 3,
//           mb: 3,
//           background: 'linear-gradient(135deg, rgba(43,140,255,0.1), rgba(0,120,255,0.05))',
//           border: '1px solid rgba(43,140,255,0.3)',
//           borderRadius: '16px'
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             mb: 1,
//             background: 'linear-gradient(90deg,#2b8cff,#6ea8ff)',
//             WebkitBackgroundClip: 'text',
//             WebkitTextFillColor: 'transparent',
//             fontWeight: 700
//           }}
//         >
//           👨‍💼 Expert Recommendations
//         </Typography>

//         <Typography sx={{ color: '#aaa', fontSize: '0.9rem' }}>
//           Book a 1:1 session with top experts based on your AI query
//         </Typography>
//       </Paper>

//       {/* Cards */}
//        <Grid container spacing={2}>
//         {experts.map((item) => {
//           const exp = item.expert;   // your API wraps it like { score, expert, user }
//           const user = item.user;

//           return (
//             <Grid item xs={12} sm={6} md={4} lg={3} key={exp.id}>
//               <StyledCard onClick={() => navigate(`/expert-profile?expert_id=${exp.user_id}`)}
//   sx={{ cursor: "pointer" }}>
//                 <CardContent sx={{ p: 2 }}>

//                   {/* Top Section */}
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
//                     <Avatar
//                       src={user?.image || ''}
//                       sx={{ width: 50, height: 50, mr: 1.5 }}
//                     />
//                     <Box>
//                       <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'white' }}>
//                         {user?.name} {user?.surname}
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#aaa' }}>
//                         {exp.designation}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   {/* Rating + Score */}
//                   <Box sx={{ mb: 1.5 }}>
//                     <Chip
//                       size="small"
//                       icon={<StarIcon sx={{ color: '#ffd700' }} />}
//                       label={`Score: ${item.score}`}
//                       sx={{ mr: 1, mb: 1, background: 'rgba(255,215,0,0.1)' }}
//                     />
//                   </Box>

//                   {/* Skills from areas_of_expertise */}
//                   <Box sx={{ mb: 1 }}>
//                     {exp.areas_of_expertise
//                       ?.split(',')
//                       .slice(0, 2)
//                       .map((skill, i) => (
//                         <Chip
//                           key={i}
//                           label={skill.trim()}
//                           size="small"
//                           sx={{
//                             mr: 1, mb: 1,
//                             background: 'rgba(255,255,255,0.08)',
//                             fontSize: '0.7rem'
//                           }}
//                         />
//                       ))}
//                   </Box>

//                   {/* About */}
//                   <Typography variant="body2" sx={{ color: '#bbb', fontSize: '0.8rem' }}>
//                     {exp.about?.slice(0, 80)}...
//                   </Typography>

//                 </CardContent>

//                 <CardActions sx={{ p: 2, pt: 0 }}>
//                   <Button
//                     fullWidth
//                     variant="contained"
//                     onClick={() => {
//           const expertObj = {
//             id: item.expert.id,          // ✅ UUID from API
//             name: `${item.user?.name || ''} ${item.user?.surname || ''}`.trim(),
//             title: item.expert.designation || 'Expert',
//             expertise: item.expert.areas_of_expertise?.split(',').map(s => s.trim()) || [],
//             image: item.user?.image || ''
//           };
//           setSelectedExpert(expertObj);  // ✅ set it
//           setBookingOpen(true);          // ✅ open modal
//           onBookSession(expertObj);      // optional — keep if parent needs it
//         }}
//                     sx={{
//                       borderRadius: '10px',
//                       py: 1,
//                       fontSize: '0.85rem',
//                       fontWeight: 600,
//                       background: 'linear-gradient(90deg,#2b8cff,#4da3ff)',
//                       boxShadow: '0 4px 12px rgba(43,140,255,0.3)',
//                       '&:hover': { background: 'linear-gradient(90deg,#1f6ed4,#2b8cff)' }
//                     }}
//                   >
//                     Book <ArrowForwardIcon sx={{ ml: 1, fontSize: 16 }} />
//                   </Button>
//                 </CardActions>

//               </StyledCard>
//             </Grid>
//           );
//         })}
//       </Grid>
//       <BookingModal
//   open={bookingOpen}
//   onClose={() => setBookingOpen(false)}
//   expert={selectedExpert}
//   onBook={(bookingData) => {
//     console.log('🎉 Booking confirmed:', bookingData);
//     // Send to backend API or Stripe
//   }}
// />
//     </Box>
//   );
// }


import React, { useState,useEffect } from 'react';
import BookingModal from '../Chatbot/BookingModel';
import {
  Box, Typography, Avatar, Chip,
  Button, Grid, Card, CardContent, CardActions
} from '@mui/material';
import CalendarTodayIcon    from '@mui/icons-material/CalendarToday';
import ArrowForwardIcon     from '@mui/icons-material/ArrowForward';
import StarIcon             from '@mui/icons-material/Star';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { useNavigate }      from 'react-router-dom';
import { styled }           from '@mui/material/styles';

// ─── Design tokens ────────────────────────────────────────────────────────────
const T = {
  blue:       '#2b8cff',
  blueDim:    'rgba(43,140,255,0.1)',
  blueBorder: 'rgba(43,140,255,0.18)',
  blueGlow:   'rgba(43,140,255,0.28)',
  surface:    'rgba(10,12,22,0.78)',
  surfaceCard:'rgba(16,18,32,0.92)',
  text:       '#e8eaf0',
  textMuted:  '#52596a',
  textSub:    '#8892a4',
  border:     'rgba(255,255,255,0.055)',
  gold:       '#ffd35c',
  goldDim:    'rgba(255,211,92,0.09)',
  goldBorder: 'rgba(255,211,92,0.22)',
};

// ─── Expert card ──────────────────────────────────────────────────────────────
const ExpertCard = styled(Card)(() => ({
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: T.surfaceCard,
  border: `1px solid ${T.border}`,
  borderRadius: '20px',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  boxShadow: '0 4px 24px rgba(0,0,0,0.38)',
  transition: [
    'transform 0.3s cubic-bezier(0.34,1.4,0.64,1)',
    'box-shadow 0.3s ease',
    'border-color 0.3s ease',
  ].join(', '),

  // top-edge shimmer line
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0, left: '15%', right: '15%',
    height: '1px',
    background: `linear-gradient(90deg, transparent, ${T.blueBorder}, transparent)`,
    pointerEvents: 'none',
  },

  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: `0 28px 56px rgba(0,0,0,0.55), 0 0 0 1px ${T.blueGlow}`,
    borderColor: 'rgba(43,140,255,0.32)',
  },

  '&:active': {
    transform: 'translateY(-3px)',
    boxShadow: '0 10px 28px rgba(0,0,0,0.4)',
  },
}));

// ─── Score pill ───────────────────────────────────────────────────────────────
function ScorePill({ score }) {
  return (
    <Box sx={{
      display: 'inline-flex', alignItems: 'center', gap: '4px',
      px: 1.1, py: '3px',
      borderRadius: '30px',
      background: T.goldDim,
      border: `1px solid ${T.goldBorder}`,
    }}>
      <StarIcon sx={{ fontSize: 11, color: T.gold }} />
      <Typography sx={{ fontSize: '0.7rem', color: T.gold, fontWeight: 700, lineHeight: 1 }}>
        {score}
      </Typography>
    </Box>
  );
}

// ─── Main component ───────────────────────────────────────────────────────────
export default function ExpertRecommendations({ onBookSession, experts = [] }) {
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [bookingOpen,    setBookingOpen]    = useState(false);
  const navigate = useNavigate();

   useEffect(() => {
  if (selectedExpert) {
    setBookingOpen(true);
  }
}, [selectedExpert]);

  if (!experts.length) return null;

 

  return (
    // ── Outer wrapper — unifies the whole section ─────────────────────────────
    <Box sx={{
      borderRadius: { xs: '0px', sm: '24px' },
      background: 'linear-gradient(160deg, rgba(7,9,18,0.98) 0%, rgba(4,6,14,0.99) 100%)',
      border: `1px solid ${T.border}`,
      backdropFilter: 'blur(28px)',
      WebkitBackdropFilter: 'blur(28px)',
      overflow: 'hidden',
      boxShadow: '0 8px 48px rgba(0,0,0,0.55)',
    }}>

      {/* ── Section header ── */}
      <Box sx={{
        px: { xs: 2.5, sm: 4, md: 5 },
        pt: { xs: 3, sm: 4 },
        pb: { xs: 2.5, sm: 3 },
        borderBottom: `1px solid ${T.border}`,
        background: 'linear-gradient(180deg, rgba(43,140,255,0.05) 0%, transparent 100%)',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}>
        {/* Icon badge */}
        <Box sx={{
          width: 46, height: 46, flexShrink: 0,
          borderRadius: '14px',
          background: T.blueDim,
          border: `1px solid ${T.blueBorder}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <WorkspacePremiumIcon sx={{ color: T.blue, fontSize: 22 }} />
        </Box>

        <Box>
          <Typography sx={{
            fontWeight: 700,
            fontSize: { xs: '1rem', sm: '1.1rem' },
            background: 'linear-gradient(90deg, #dde4f0 20%, #6ea8ff 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            lineHeight: 1.25,
          }}>
            Expert Recommendations
          </Typography>
          <Typography sx={{ color: T.textMuted, fontSize: '0.77rem', mt: '3px' }}>
            {experts.length} expert{experts.length > 1 ? 's' : ''} matched to your query
          </Typography>
        </Box>
      </Box>

      {/* ── Cards grid ── */}
      <Box sx={{
        px: { xs: 2, sm: 3.5, md: 5 },
        py: { xs: 3, sm: 3.5, md: 4 },
      }}>
        <Grid container spacing={{ xs: 2, sm: 2.5 }}>
          {experts.map((item) => {
            const exp    = item.expert;
            const user   = item.user;
            const skills = exp.areas_of_expertise
              ?.split(',').map(s => s.trim()).filter(Boolean) || [];

            return (
              <Grid item xs={12} sm={6} lg={4} xl={3} key={exp.id}
                sx={{ display: 'flex' }}
              >
                <ExpertCard
                  onClick={() => navigate(`/expert-profile?expert_id=${exp.user_id}`)}
                  sx={{ width: '100%' }}
                >
                  <CardContent sx={{
                    flex: 1,
                    p: { xs: '20px !important', sm: '24px !important' },
                    pb: '10px !important',
                  }}>

                    {/* ── Avatar + name + score ── */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.75, mb: 2.5 }}>
                      <Avatar
                        src={user?.image || ''}
                        sx={{
                          width: 52, height: 52, flexShrink: 0,
                          background: 'linear-gradient(135deg, #0d2145 0%, #162f5c 100%)',
                          color: '#6ea8ff',
                          fontSize: '1.1rem', fontWeight: 700,
                          border: `1.5px solid ${T.blueBorder}`,
                          boxShadow: `0 0 0 3px ${T.blueDim}`,
                        }}
                      >
                        {!user?.image && user?.name?.charAt(0).toUpperCase()}
                      </Avatar>

                      <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography sx={{
                          fontWeight: 600, color: T.text,
                          fontSize: '0.88rem', lineHeight: 1.3,
                          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        }}>
                          {user?.name} {user?.surname}
                        </Typography>
                        <Typography sx={{
                          color: '#4da3ff', fontSize: '0.72rem', mt: '2px',
                          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        }}>
                          {exp.designation}
                        </Typography>
                        <Box sx={{ mt: '7px' }}>
                          <ScorePill score={item.score} />
                        </Box>
                      </Box>
                    </Box>

                    {/* ── Divider ── */}
                    <Box sx={{
                      height: '1px',
                      background: `linear-gradient(90deg, ${T.blueBorder}, transparent)`,
                      mb: 2,
                    }} />

                    {/* ── Skill chips ── */}
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '5px', mb: 2 }}>
                      {skills.slice(0, 3).map((skill, i) => (
                        <Chip key={i} label={skill} size="small" sx={{
                          height: 22,
                          background: T.blueDim,
                          border: `1px solid ${T.blueBorder}`,
                          color: '#7ab8ff',
                          fontSize: '0.67rem', fontWeight: 500,
                          borderRadius: '6px',
                          '& .MuiChip-label': { px: '8px' },
                        }} />
                      ))}
                    </Box>

                    {/* ── About ── */}
                    <Typography sx={{
                      color: T.textMuted,
                      fontSize: '0.77rem',
                      lineHeight: 1.7,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}>
                      {exp.about?.slice(0, 100)}{exp.about?.length > 100 ? '…' : ''}
                    </Typography>

                  </CardContent>

                  {/* ── Book button ── */}
                  <CardActions sx={{
                    p: { xs: '14px 20px 20px', sm: '14px 24px 24px' },
                  }}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<CalendarTodayIcon sx={{ fontSize: '13px !important' }} />}
                      endIcon={
                        <ArrowForwardIcon sx={{
                          fontSize: '14px !important',
                          transition: 'transform 0.22s ease',
                        }} />
                      }
                      onClick={(e) => {
                        e.stopPropagation();   // prevent card navigate
                        const expertObj = {
                          id:        item.expert.id,
                          name:      `${item.user?.name || ''} ${item.user?.surname || ''}`.trim(),
                          title:     item.expert.designation || 'Expert',
                          expertise: item.expert.areas_of_expertise?.split(',').map(s => s.trim()) || [],
                          image:     item.user?.image || '',
                           consultation_fee: item.expert.consultation_fee,
                        };
                        console.log("Expert object:", expertObj);
                        setSelectedExpert(expertObj);
                       
                        onBookSession(expertObj);
                      }}
                      sx={{
                        borderRadius: '12px',
                        py: 1.15,
                        fontSize: '0.8rem', fontWeight: 600,
                        textTransform: 'none', letterSpacing: '0.025em',
                        background: 'linear-gradient(90deg, #1558b0, #2b8cff)',
                        boxShadow: '0 4px 18px rgba(43,140,255,0.2)',
                        border: '1px solid rgba(43,140,255,0.22)',
                        transition: 'all 0.22s ease',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #2b8cff, #5ab4ff)',
                          boxShadow: '0 8px 30px rgba(43,140,255,0.38)',
                          transform: 'translateY(-1px)',
                          '& .MuiButton-endIcon svg': { transform: 'translateX(3px)' },
                        },
                        '&:active': {
                          transform: 'scale(0.98)',
                          boxShadow: '0 2px 10px rgba(43,140,255,0.18)',
                        },
                      }}
                    >
                      Book Session
                    </Button>
                  </CardActions>

                </ExpertCard>
              </Grid>
            );
          })}
        </Grid>
 
      </Box>
               {selectedExpert && (
  <BookingModal
    open={bookingOpen}
    onClose={() => setBookingOpen(false)}
    expert={selectedExpert}
  />
)}
    </Box>
  );
}